import React from 'react';
const _ = {
    find:  require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    forEach:    require('lodash/forEach'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');
const ShortCourseConstants =        require('../../../../app/shared/ShortCourseConstants');
const COACH_CONDITION = ShortCourseConstants.COACH_CONDITION;

const BOOL_VALUES = {
    "true": Strings["en"].common.TRUE,
    "false": Strings["en"].common.FALSE,
    "undefined": Strings["en"].common.DONT_CARE,
};

// title = "Action Conditions"
function CoachConditionEditor({title,conditions,onChangeConditions,onClose}) {
    // currently, all conditions are boolean with just the type
    // and you can only have one of each
    if (!conditions) {
        conditions = [];
    }
    function setCondition(type,value) {
        conditions=conditions.slice();
        let i = _.findIndex(conditions,{type});
        if (value === 'undefined') {
            if (i < 0) {
                return;
            }
            conditions.splice(i,1); // delete condition
        }
        else {
            value = (value === "true"); // "true" = true, "false" = false
            if (i>=0) {
                conditions[i] = {type, value};
            }
            else {
                conditions.push({type,value});
            }
        }
        onChangeConditions(conditions);
    }
    
    let allConditions = conditions.slice();
    _.forEach(COACH_CONDITION,(type)=>{
        if (!_.find(allConditions,{type})) {
            allConditions.push({type,value:undefined});
        }
    });

    return (
        <div className="coach-condition-editor">
            <h2>{title}
                <span className="fa fa-close" onClick={onClose} aria-hidden />
            </h2>
            <div className="condition-editor-body">
                <label>{Strings['en'].short_course.available_conditions_title}</label>
                <div className="boolean-conditions">
                { _.map(allConditions,(c,k)=>{
                    let {type,value} = c;
                    let title = Strings['en'].short_course.coach_condition_descriptions[type];
                    return (
                    <div className="condition-edit-row" key={k}>
                        <label title={title}>{type+':'}</label>
                        <select value={String(value)} onChange={(e)=>{setCondition(type,e.target.value)}}>
                            {_.map(BOOL_VALUES,(displayName,boolStringValue)=>(
                                <option key={`k-${boolStringValue}`} value={boolStringValue}>
                                    {displayName}
                                </option>
                            ))}
                        </select>
                    </div>
                    )
                })}
                </div>
            </div>
        </div>
    );
}

function CoachConditionsLine({conditions,onChangeConditions,expanded,toggleExpanded}) {
    let conditionEditor = null;
    if (expanded) {
        conditionEditor = (
            <CoachConditionEditor
                conditions={conditions}
                onChangeConditions={onChangeConditions}
                onClose={toggleExpanded}/>
        );
    }
    let conditionItems = [];
    _.forEach(conditions,(c,i)=>{
        let title = Strings['en'].short_course.coach_condition_descriptions[c.type] || '';
        let c_text = c.value ? c.type : `not ${c.type}`;
        conditionItems.push(
            <span key={i} className="condition-type" title={title}>{c_text}</span>
        );
    });
    if (!conditionItems.length) {
        conditionItems.push(
            <span key="none" className="condition-type" title={Strings['en'].short_course.coach_condition_descriptions.NO_CONDITIONS}>{Strings['en'].common.NONE}</span>
        );
    }

    return (
        <span className="edit-selector condition-column" onClick={conditionEditor ? null : toggleExpanded}>
            <label>{Strings['en'].short_course.CONDITIONS + ':'}</label>
            <span className="action-conditions-text">{conditionItems}</span>
            { conditionEditor } 
        </span>
    )
}

export default CoachConditionsLine;